import React, { ReactElement } from 'react';
import { Button, Row, LoaderButton } from 'idsk-react-components';
import './createAndUpdatePripomienkaAdminButtons.scss';
import { useLocation, useNavigate } from 'react-router';
import { ConfirmModal } from 'slovlex-idsk-react-components';

interface Props {
  loading: boolean;
  onSubmit: () => void;
  getBackUrl: () => string;
}

const CreateAndUpdatePripomienkaAdminButtons = ({
  onSubmit, loading, getBackUrl,
}: Props): ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Row className="create-update-pripomienka-admin__form-buttons-container">
      <ConfirmModal
        question={location.pathname.endsWith('uprav/admin')
          ? 'Naozaj si želáte zmeny uložiť?' : 'Naozaj si želáte pridať danú pripomienku?'}
        cancelButtonText="Nie"
        confirmButton={(<Button buttonStyle="action" size="large">Áno</Button>)}
        openButton={(
          <LoaderButton
            loading={loading}
            type="submit"
            size="large"
          >{location.pathname.endsWith('uprav/admin') ? 'Uložiť' : 'Pridať'}
          </LoaderButton>
        )}
        doAfterConfirm={onSubmit}
      />
      <Button
        onClick={() => {
          const hasPreviousState = location.key !== 'default';
          if (hasPreviousState) {
            navigate(-1);
          } else {
            navigate(getBackUrl());
          }
        }}
        type="reset"
        buttonStyle="secondary"
        size="large"
      >Zrušiť
      </Button>
    </Row>
  );
};

export default CreateAndUpdatePripomienkaAdminButtons;
